import { motion } from "framer-motion";
import { useState } from "react";
import { 
  FaGavel, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, 
  FaShieldAlt, FaWhatsapp, FaInstagram, FaFacebook, FaYoutube, FaPaperPlane 
} from "react-icons/fa";

export default function Contact() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => { 
    setForm({ ...form, [e.target.name]: e.target.value }); 
  };

  // --- WHATSAPP LOGIC ---
  const sendToWhatsApp = () => {
    if(!form.name || !form.phone) {
      alert("Please enter at least Name and Phone for WhatsApp.");
      return;
    }
    const msg = encodeURIComponent(
      `*🔥 New Web Enquiry: Eagle Force* \n\n` +
      `*Name:* ${form.name}\n` +
      `*Phone:* ${form.phone}\n` +
      `*Email:* ${form.email}\n` +
      `*Message:* ${form.message}`
    );
    window.open(`https://wa.me/919967875227?text=${msg}`, "_blank");
  };

  // --- EMAIL LOGIC ---
  const sendToEmail = () => {
    if(!form.name || !form.email) {
      alert("Please enter Name and Email.");
      return;
    }
    const subject = encodeURIComponent(`New Lead: ${form.name}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\nPhone: ${form.phone}\nEmail: ${form.email}\n\nMessage:\n${form.message}`
    );
    window.location.href = `mailto:#?subject=${subject}&body=${body}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Default action hum WhatsApp rakhte hain kyunki wo fast hai
    sendToWhatsApp();
  };

  return (
    <div style={styles.container}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@700&family=Inter:wght@400;600&display=swap');
        .matrix-bg { position: fixed; inset: 0; background: #000; background-image: linear-gradient(0deg, rgba(0, 224, 255, 0.05) 1px, transparent 1px); background-size: 100% 40px; animation: matrixMove 10s linear infinite; z-index: 0; }
        @keyframes matrixMove { 0% { background-position: 0 0; } 100% { background-position: 0 1000px; } }
        .cyber-card { background: rgba(10, 10, 15, 0.9) !important; border: 1px solid #1a1a1a !important; transition: 0.4s; border-radius: 15px; padding: 50px; }
        .cyber-card:hover { border-color: #00e0ff !important; box-shadow: 0 0 30px rgba(0, 224, 255, 0.1); }
        .map-box { width: 100%; height: 55vh; border-top: 2px solid #00e0ff; position: relative; overflow: hidden; margin-top: 60px; }
        .radar-line { position: absolute; top: 0; width: 100%; height: 2px; background: #00e0ff; box-shadow: 0 0 20px #00e0ff; animation: radar 5s linear infinite; }
        @keyframes radar { 0% { top: 0%; } 100% { top: 100%; } }
        @media (max-width: 900px) { .mobile-grid { grid-template-columns: 1fr !important; } .cyber-card { padding: 30px; } }
      `}</style>

      <div className="matrix-bg" />

      <div style={styles.content}>
        <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} style={styles.header}>
          <h1 style={styles.title}>EAGLE <span style={{color: '#00e0ff'}}>FORCE</span></h1>
          <p style={styles.subText}>Premium Security & Legal Protection Services.</p>
        </motion.div>

        <div className="mobile-grid" style={styles.grid}>
          {/* INFO CARD */}
          <motion.div initial={{ x: -50, opacity: 0 }} whileInView={{ x: 0, opacity: 1 }} viewport={{ once: true }} className="cyber-card">
            <h3 style={styles.cardTitle}>// COMMAND CENTER</h3>
            <div style={styles.infoLine}><FaPhoneAlt color="#00e0ff" /> +91 9967875227</div>
            <div style={styles.infoLine}><FaEnvelope color="#00e0ff" /> info@eagleforce.in</div>
            <div style={styles.infoLine}><FaMapMarkerAlt color="#00e0ff" /> Balkum, Thane, MH 400601</div>
            
            <div style={styles.socialRow}>
              <SocialIcon href="https://wa.me/919967875227" icon={<FaWhatsapp />} color="#25D366" />
              <SocialIcon href="#" icon={<FaInstagram />} color="#E1306C" />
              <SocialIcon href="#" icon={<FaFacebook />} color="#1877F2" />
              <SocialIcon href="#" icon={<FaYoutube />} color="#FF0000" />
            </div>
          </motion.div>

          {/* FORM CARD */}
          <motion.div initial={{ x: 50, opacity: 0 }} whileInView={{ x: 0, opacity: 1 }} viewport={{ once: true }} className="cyber-card">
            <h3 style={styles.cardTitle}>// INITIALIZE ENQUIRY</h3>
            <form onSubmit={handleSubmit} style={styles.form}>
              <input type="text" placeholder="Your Name" name="name" value={form.name} onChange={handleChange} style={styles.input} required />
              <input type="tel" placeholder="Phone Number" name="phone" value={form.phone} onChange={handleChange} style={styles.input} required />
              <input type="email" placeholder="Email Address" name="email" value={form.email} onChange={handleChange} style={styles.input} required />
              <textarea placeholder="How can we secure you today?" name="message" value={form.message} onChange={handleChange} style={styles.textarea} required />
              
              <div style={styles.btnGroup}>
                <motion.button 
                  type="submit"
                  whileHover={{ scale: 1.02, backgroundColor: '#25D366', color: '#fff', borderColor: '#25D366' }}
                  whileTap={{ scale: 0.98 }}
                  style={{...styles.btn, borderColor: '#25D366', color: '#25D366'}}
                >
                  <FaWhatsapp /> WHATSAPP
                </motion.button>

                <motion.button 
                  type="button"
                  onClick={sendToEmail}
                  whileHover={{ scale: 1.02, backgroundColor: '#00e0ff', color: '#000' }}
                  whileTap={{ scale: 0.98 }}
                  style={styles.btn}
                >
                  <FaEnvelope /> EMAIL
                </motion.button>
              </div>
            </form>
          </motion.div>
        </div>

        {/* LEGAL STRIP */}
        <motion.div initial={{ y: 30, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} viewport={{ once: true }} style={styles.lawyerStrip}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <FaGavel size={40} color="#00e0ff" style={{ filter: 'drop-shadow(0 0 10px #00e0ff)' }} />
            <div>
              <p style={{ margin: 0, fontWeight: 'bold', fontFamily: 'Orbitron', fontSize: '18px' }}>LEGAL SUPPORT</p>
              <p style={{ margin: 0, fontSize: 13, opacity: 0.7 }}>Registration & Rental Agreements by Experts.</p>
            </div>
          </div>
          {/* LINK LOGIC ADDED HERE */}
          <motion.button 
            onClick={() => window.open("https://adv-surya.vercel.app/", "_blank")}
            whileHover={{ scale: 1.05, boxShadow: "0 0 15px #00e0ff" }} 
            style={styles.lawBtn}
          >
            VISIT LEGAL PORTAL <FaShieldAlt />
          </motion.button>
        </motion.div>
      </div>

      <div className="map-box">
        <div className="radar-line" />
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3766.756285223793!2d72.98687257521025!3d19.227632981928373!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b9365319889d%3A0xc6c42171e8470a1!2sEagle%20Force%20Security%20and%20House%20Keeping!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
          style={styles.mapIframe} allowFullScreen="" loading="lazy" title="Thane Location"
        />
      </div>
    </div>
  );
}

function SocialIcon({ href, icon, color }) {
  return (
    <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{ y: -5, color: color, scale: 1.2 }} style={{ color: '#fff', fontSize: 32, transition: '0.3s' }}>
      {icon}
    </motion.a>
  );
}

const styles = {
  container: { background: "#000", color: "#fff", position: "relative", minHeight: "100vh", overflowX: "hidden" },
  content: { position: "relative", zIndex: 10, maxWidth: "1200px", margin: "0 auto", padding: "100px 20px 0 20px" },
  header: { textAlign: "center", marginBottom: 70 },
  title: { fontSize: "clamp(35px, 8vw, 60px)", fontWeight: "900", fontFamily: 'Orbitron', letterSpacing: 3, margin: 0 },
  subText: { color: "#888", fontSize: "16px", marginTop: 15, fontFamily: 'Inter' },
  grid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "40px" },
  cardTitle: { color: "#00e0ff", fontSize: "14px", fontFamily: 'Orbitron', marginBottom: "35px", letterSpacing: 2 },
  infoLine: { display: "flex", alignItems: "center", gap: "20px", marginBottom: "30px", fontSize: "17px", fontFamily: 'Inter' },
  socialRow: { display: "flex", gap: "35px", marginTop: "40px" },
  form: { display: "flex", flexDirection: "column", gap: "20px" },
  input: { padding: "18px", background: "#0a0a0f", border: "1px solid #1a1a1a", color: "#fff", borderRadius: "8px", outline: "none" },
  textarea: { padding: "18px", background: "#0a0a0f", border: "1px solid #1a1a1a", color: "#fff", borderRadius: "8px", minHeight: "120px", resize: "none" },
  btnGroup: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' },
  btn: { padding: "18px", background: "transparent", border: "2px solid #00e0ff", color: "#00e0ff", fontWeight: "bold", borderRadius: "8px", cursor: "pointer", fontFamily: 'Orbitron', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' },
  lawyerStrip: { margin: "80px 0", background: "linear-gradient(90deg, rgba(0, 224, 255, 0.1), transparent)", borderLeft: "5px solid #00e0ff", padding: "40px", borderRadius: "10px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "20px" },
  lawBtn: { background: "#00e0ff", color: "#000", border: "none", padding: "15px 35px", fontWeight: "bold", borderRadius: "8px", fontSize: "13px", fontFamily: 'Orbitron', display: 'flex', alignItems: 'center', gap: 10, cursor: "pointer" },
  mapIframe: { width: "100%", height: "100%", border: "none", filter: "invert(90%) hue-rotate(180deg) brightness(0.7) contrast(1.2)" }
};